import { gql } from "lib/apolloClient";
import { attachmentFragment } from "modules/CommonFragments";
import { modalitiesFragments } from "./AIChatFragments";

export const getAttachmentModalityQuery = gql`
  query getAttachmentModality($id: ID!) {
    node(id: $id, type: ATTACHMENT) {
      id
      ... on Attachment {
        id
        name
        type
        metadata
        modalityAttachment {
          ...modalityAttachmentItem
        }
      }
    }
  }
  ${modalitiesFragments.modalityAttachment}
`;

export const getAIConversationAttachmentsQuery = gql`
  query getAIConversationAttachments($id: ID!) {
    node(id: $id, type: AI_CONVERSATION) {
      id
      ... on AiConversation {
        id
        attachments {
          ...attachmentItem
        }
      }
    }
  }
  ${attachmentFragment.attachment}
`;
